import { SCAMS_API_URL } from "../API_URL";
import { callAPI } from "../helper";

export const postScam = (formData) => {
  const headers = {
    "Content-Type": "multipart/form-data",
  };
  const endpoint = SCAMS_API_URL + "/postScam";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, formData);
};
export function getSuggestedScams(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/fetchAllScamsAlertsWithReactionComment";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function getSingleScamPostbyScamIdApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/getSingleScamPostbyScamId";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function fetchMyScamAlerts(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/fetchMyScamAlertsWithReactions";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function searchScamByPostId(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/searchScamByPostId";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function updateReaction(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/react";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function fetchRedirectionLinksApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/fetchRedirectionLinks";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function fetchAllScamsAlertsWithReactionsApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/fetchAllScamsAlertsWithReactions";
  // const endpoint = SCAMS_API_URL + "/fetch3ScamAlertsWithReactions";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function createComment(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/createComment";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function deleteScamApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/deleteScam";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function deleteComment(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/deleteComment";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function getCommentsByScamId(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/getCommentsByScamId";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}

export function getCommentRepliesByCommentIdApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/getCommentRepliesByCommentId";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function postReplyToCommentApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/postReplyToComment";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function deleteReplyOnCommentApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/deleteReplyOnComment";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}
export function toggleReplyReactionApi(param) {
  const headers = {};
  const endpoint = SCAMS_API_URL + "/toggleReplyReaction";
  const requestMethod = "POST";
  return callAPI(headers, endpoint, requestMethod, param);
}